(function () {
    const swal = require("sweetalert");
    const Choices = require("choices.js");

    const deleteButtons = document.querySelectorAll(".btn-delete");

    deleteButtons.forEach((button) => {
        button.addEventListener("click", function (event) {
            event.preventDefault();
            const id = event.target.getAttribute("data-id");
            swal({
                title: "Você está certo?",
                text: "Uma vez deletado, você não poderá recuperar esse item novamente!",
                icon: "warning",
                buttons: true,
                buttons: ["Cancelar", "Excluir"],
                dangerMode: true,
            }).then((isConfirm) => {
                if (isConfirm) {
                    document.getElementById(`form-delete-${id}`).submit();
                }
            });
        });
    });

    const inputsRequired = document.querySelectorAll(
        "input[required], select[required], textarea[required]"
    );

    inputsRequired.forEach((input) => {
        input.previousElementSibling.classList.add("required");
    });

    let choices = document.querySelectorAll(".choices");
    let initChoice;
    for (let i = 0; i < choices.length; i++) {
        if (choices[i].classList.contains("multiple-remove")) {
            initChoice = new Choices(choices[i], {
                delimiter: ",",
                editItems: true,
                maxItemCount: -1,
                removeItemButton: true,
                loadingText: "Carregando...",
                noResultsText: "Nenhum resultado encontrado",
                noChoicesText: "Sem opções para escolher",
                itemSelectText: "",
            });
        } else {
            initChoice = new Choices(choices[i], {
                loadingText: "Carregando...",
                noResultsText: "Nenhum resultado encontrado",
                noChoicesText: "Sem opções para escolher",
                itemSelectText: "",
            });
        }
    }

    $(".city").select2({
        minimumInputLength: 3,
        language: "pt-BR",
        placeholder: "Selecione a Cidade",
        width: "100%",
        theme: "bootstrap-5",
        ajax: {
            cache: true,
            url: "/api/v1/cities",
            dataType: "json",
            data: function (params) {
                var query = {
                    search: params.term,
                };
                return query;
            },
            processResults: function (response) {
                var results = [];

                $.each(response.data, function (i, v) {
                    var o = {};
                    o.id = v.id;
                    o.text = v.title + " - " + v.letter;
                    o.value = v.id;
                    results.push(o);
                });
                return {
                    results: results,
                };
            },
        },
    });

    $(".btn-image").on("click", function () {
        $(this).next(".images").click();
    });

    $(".images").on("change", function () {
        var field = $(this);
        var files = !!this.files ? this.files : [];
        if (!files.length || !window.FileReader) return;

        if (/^image/.test(files[0].type)) {
            var reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onloadend = function () {
                //Changed below line as well to show preview next to the changed element
                field.siblings(".preview-image").attr("src", this.result);
            };
        }
    });

    $(".summernote").summernote({
        tabsize: 2,
        lang: "pt-BR",
    });

    $body = $("body");

    $(document).on({
        ajaxStart: function () {
            $body.addClass("loading");
        },
        ajaxStop: function () {
            $body.removeClass("loading");
        },
    });

    $(".btn-print").on("click", printPage);
})();

function printPage() {
    let body = document.body.cloneNode(true);
    let print = document.querySelector(".print").cloneNode(true);
    document.body.innerHTML = "";
    document.body.appendChild(print);
    window.print();
    document.body.innerHTML = "";
    document.body.appendChild(body);
    location.reload();
}
